<div class="wrapper wrapper-dark">
  <div class="title-section mb-5">Admin Area</div>

  <div class="mt-5">

    <div class="tabs-wrapper">
      <span>
        <span class="tab-item" [ngClass]="{'arrow-green': selectedArea=='homepage'}" (click)="changeSection('homepage')">Elenco Homepage</span>
        <div class="arrow-right" *ngIf="selectedArea=='homepage'"></div>
      </span>

      <span>
        <span class="tab-item" [ngClass]="{'arrow-green': selectedArea=='customer'}" (click)="changeSection('customer')">Clienti</span>
        <div class="arrow-right" *ngIf="selectedArea=='customer'"></div>
      </span>

      <span>
        <span class="tab-item" [ngClass]="{'arrow-green': selectedArea=='projects'}" (click)="changeSection('projects')">Progetti</span>
        <div class="arrow-right" *ngIf="selectedArea=='projects'"></div>
      </span>

      <span>
        <span class="tab-item" [ngClass]="{'arrow-green': selectedArea=='work-with-us'}" (click)="changeSection('work-with-us')">Lavora con noi</span>
        <div class="arrow-right" *ngIf="selectedArea=='work-with-us'"></div>
      </span>

      <!-- Inizio Codice Shinystat OLD -->
      <div class="counter mt-4 ml-3">
        <script type="text/javascript" language="JavaScript" src="http://codice.shinystat.com/cgi-bin/getcod.cgi?USER=Panetta"></script>
          <a href="http://www.shinystat.com" target="_top">
            <img src="http://www.shinystat.com/cgi-bin/shinystat.cgi?USER=Panetta" alt="ROI tracking">
          </a>
      </div>
      <!-- Fine Codice Shinystat -->

      <!-- Inizio Codice ShinyStat NEW -->
      <div class="counter mt-4 ml-3">
        <script src="//codice.shinystat.com/cgi-bin/getcod.cgi?USER=SS-48880081-59efd"></script>
        <!--<noscript>-->
          <a href="https://www.shinystat.com/it/" target="_top">
            <img src="//www.shinystat.com/cgi-bin/shinystat.cgi?USER=SS-48880081-59efd" alt="Statistiche web" style="border:0px" /></a>
        <!--</noscript>-->
      </div>
      <!-- Fine Codice ShinyStat -->

    </div>

    <div class="content-wrapper" *ngIf="selectedArea=='homepage'">
      <app-homepage-management></app-homepage-management>
    </div>
    <div class="content-wrapper" *ngIf="selectedArea=='customer'">
      <app-customer-management></app-customer-management>
    </div>
    <div class="content-wrapper" *ngIf="selectedArea=='projects'">
      <app-projects-management></app-projects-management>
    </div>
    <div class="content-wrapper" *ngIf="selectedArea=='work-with-us'">
      <app-work-with-us-management></app-work-with-us-management>
    </div>
  </div>
</div>
<loader></loader>